import React from 'react';

import MIcon from 'app/ui/MIcon/MIcon';

import { OrderType } from 'app/enums/order-types';

import { ITab } from './BarTabs.model';
import classes from './BarTabs.module.scss';
import { condClass } from 'app/utils/general';

interface Props {
  tabs: ITab[] | null;
  orderType: OrderType | null;
  onSelectedTab: (tab: OrderType) => void;
}

const BarTabsView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <ul className={condClass({ [classes['container']]: !!props.tabs })}>
      {props.tabs?.map((tab: ITab) => {
        return (
          <li key={tab.value}>
            <button onClick={() => props.onSelectedTab(tab.value)}>
              <div className={condClass({ [classes['content']]: true, [classes['selected']]: props.orderType === tab.value })}>
                <div className={classes['icon']}>
                  <MIcon name={tab.icon} className={classes['icon__object']}></MIcon>
                </div>
                <span className={classes['label']}>{tab.label}</span>
              </div>
            </button>
          </li>
        );
      }) || null}
    </ul>
  );
};

BarTabsView.displayName = 'BarTabsView';
BarTabsView.defaultProps = {};

export default BarTabsView;
